import { OrderDetailsAPIExport } from "node-library/dist/apiDataFormats";
import {
	FrontendOrganization,
	FrontendUserInfo,
} from "node-library/dist/portal";
import { useState } from "react";
import { GreenButton } from "../../../common-components/button";
import { useSnackbar } from "../../../common-components/toast/showToastMessage";
import { useTranslation } from "react-i18next";
import { Card } from "@mui/material";
import { DataHandleOption } from "node-library/dist/constants";

interface Props {
	oldData: string | React.ReactNode;
	newData: string | React.ReactNode;
	dataHandleOption: DataHandleOption;
}

export default function CPDifferentInfoRow(props: Props) {
	const { oldData, newData, dataHandleOption } = props;

	let row: React.ReactNode;
	if (dataHandleOption === DataHandleOption.USE_NEW) {
		row = (
			<div className="cp-details-different-info-row">
				<span
					className="cp-details-data-cell"
					style={{ backgroundColor: "#ffc0cb" }}
				>
					<s>{oldData}</s>
				</span>
				<span style={{ padding: "0 10px" }}>&#8594;</span>{" "}
				{/* Right arrow using Unicode */}
				<span
					className="cp-details-data-cell"
					style={{ backgroundColor: "#d1fae8" }}
				>
					{newData}
				</span>
			</div>
		);
	} else {
		row = (
			<div className="cp-details-different-info-row">
				<span className="cp-details-data-cell">{oldData}</span>
				<span style={{ padding: "0 10px", opacity: 0.5 }}>&#8594;</span>{" "}
				<span className="cp-details-data-cell" style={{ opacity: 0.5 }}>
					<s>{newData}</s>
				</span>
			</div>
		);
	}

	return row;
}
